import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
          页面未找到
        </h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm md:text-base text-foreground-600">
          抱歉，您访问的页面不存在或已被移除
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-all text-sm whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}